// src/layouts/LayoutWithHeader.tsx
import logo from "@/assets/logo.svg";
import Menu from "@/components/Menu";
import style from "./index.module.less";
import { ConnectWallet } from "@/components/ConnectWallet";

const LayoutWithHeader = () => {
  return (
    <div className={style.header}>
      <div className={style.left}>
        {/* <div className={style.logo}>
          <img src={logo} alt="Logo" />
        </div> */}
        <div className={style.menu}>
          <Menu></Menu>
        </div>
      </div>
      <div className={style.right}>
        <ConnectWallet />
      </div>
    </div>
  );
};

export default LayoutWithHeader;
